import { apiInstance } from "./networking";
export const coUploadDocument = async (payload) => {
    const {data = {}} = await apiInstance.post(`primary/corporate-document-upload`,payload);
    return data;
};

